import { Modal } from "react-bootstrap";
import ButtonSubmit from "../common/buttonSubmit";
import ButtonWhite from "../common/buttonWhite";
import ErrorMessageBox from "../common/errorMessageBox";
import AlertMessage from "../alertMessage";

const alertMessageModal = (props: any) => {
  let show = props.show ?? false;
  let title = props.title ?? "";
  let description = props.description ?? "";
  let titleButtonSecondary = props.titleButtonSecondary ?? "";
  let titleButtonPrimary = props.titleButtonPrimary ?? "";
  let alertMessage = props.alertMessage ?? "";
  let errorMessage = props.errorMessage ?? "";
  let spinnerButtonSecondary = props.spinnerButtonSecondary ?? false;
  let classNameButtons = props.classNameButtons ? props.classNameButtons : "";
  const closeModal = () => {
    show = false;
  };
  const handleClose = () => {
    show = false;
  };
  return (
    <Modal show={show} onHide={props.closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {alertMessage && <AlertMessage description={alertMessage} />}

        {description}
        <div className="col-lg-12 mx-auto">
          <ErrorMessageBox errorMessage={errorMessage} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <>
          {titleButtonSecondary && (
            <ButtonWhite
              textButton={titleButtonSecondary}
              handleChange={props.handleCloseSecondary}
              className={classNameButtons}
            />
          )}
          {titleButtonPrimary && (
            <ButtonSubmit
              spinner={spinnerButtonSecondary}
              textButton={titleButtonPrimary}
              handleChange={props.handleClosePrimary}
              className={classNameButtons}
            />
          )}
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default alertMessageModal;
